// import styles from "./style.module.scss";
import React, { useState, useEffect } from 'react';
import DataTable from '../../components/DataTable';
import PageHeading from '../../components/PageHeading';
import { Link, useSearchParams } from 'react-router-dom';
import { LOCALSTORAGE_TOKEN_LABEL } from '../../constants';
import { ANNOTATOR_API } from '../../api-handle';

/**
 * Annotations component:
 * This component is responsible to display the latest annotation of an event
 * fetched from the API server via event ID.
 */
export default function Annotations() {
  const [isLoading, setIsLoading] = useState(false);
  // const [currentPage, setCurrentPage] = useState(1);
  // const [pageSize, setPageSize] = useState(5);
  // const [totalItems, setTotalItems] = useState(25);
  // const [totalPages, setTotalPages] = useState(5);
  const [data, setData] = useState(null);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams && searchParams.get('eventID')) {
      setIsLoading(true);
      ANNOTATOR_API.getAnnotationsOfEvent(
        window.localStorage.getItem(LOCALSTORAGE_TOKEN_LABEL),
        searchParams.get('eventID')
      )
        .then((res) => {
          setData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log(err);
        });
    }
  }, [searchParams]);

  const columns = [
    {
      Header: 'Date',
      accessor: 'createdAt',
    },
    {
      Header: 'Client IP',
      accessor: 'lastModifiedIP',
    },
    {
      Header: 'Class Label',
      accessor: 'annotations',
    },
    {
      Header: 'Comments',
      accessor: 'comments',
    },
  ];

  return (
    <div className="container">
      <div className="bg-white rounded-15 shadow-sm px-3 pb-2">
        <PageHeading title="Annotations" />
        {!isLoading &&
          data &&
          (data.annotation ? (
            <DataTable
              topContent={
                <div
                  className={
                    'd-flex flex-column justify-content-center ' +
                    'align-items-center pt-4'
                  }
                >
                  <Link
                    to={`/event-details?id=${searchParams.get('eventID')}`}
                    className="btn btn-primary"
                  >
                    Event Details <i className="bi bi-arrow-right ms-2"></i>
                  </Link>
                </div>
              }
              topContentAlignment="right"
              topContentColRatioLeft="10"
              topContentColRatioRight="2"
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              filter
              sort
              data={[data.annotation]}
              // showPagination
              // showPageSizeChanger
              columns={columns}
              // totalPages={totalPages}
              // totalItems={totalItems}
              // handleChangePageNo={(newPageNo) => {
              //   setCurrentPage((prev) => newPageNo);
              // }}
              // currentPageNo={currentPage}
              // currentPageSize={pageSize}
              // handleChangePageSize={(newPageSize) => {
              //   setPageSize((prev) => newPageSize);
              // }}
            />
          ) : (
            <div className="text-center">No annotations found</div>
          ))}
      </div>
    </div>
  );
}
